import React from "react"

const Map = (props) => {
    return (
        <div id="map" style={props.style}>
            {props.children}
        </div>
    )
}

export default Map